/* Renis Wollshop — small shared behaviours: toast notifications, mobile menu, cookie banner. */
(function () {
  'use strict';

  var ICONS = {
    positive: '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>',
    neutral: '<path d="M12 16v-4M12 8h.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0z"/>',
    warning: '<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01"/>',
    danger: '<path d="M12 8v4M12 16h.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0z"/>'
  };

  function toast(opts) {
    var region = document.getElementById('rw-toast-region');
    if (!region) {
      region = document.createElement('div');
      region.id = 'rw-toast-region';
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    var scheme = opts.scheme || 'neutral';
    var el = document.createElement('div');
    el.className = 'rw-notification rw-notification--' + scheme;
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="rw-notification__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      (ICONS[scheme] || ICONS.neutral) +
      '</svg></span>' +
      '<div><div class="rw-notification__title">' + (opts.title || '') + '</div>' +
      (opts.description ? '<div class="rw-notification__desc">' + opts.description + '</div>' : '') +
      '</div>';
    region.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity 200ms ease';
      el.style.opacity = '0';
      setTimeout(function () { el.remove(); }, 200);
    }, 3000);
  }
  window.RWToast = toast;

  // mobile menu / search drawers
  function backdropFor(id) { return document.querySelector('[data-backdrop-for="' + id + '"]'); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-menu-open]');
    if (openBtn) {
      var id = openBtn.getAttribute('aria-controls');
      var drawer = document.getElementById(id);
      if (drawer) {
        drawer.dataset.open = 'true';
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var bd = backdropFor(id);
        if (bd) bd.dataset.open = 'true';
        var input = drawer.querySelector('input[type="search"]');
        if (input) input.focus();
      }
      return;
    }
    var closeBtn = e.target.closest('[data-menu-close]');
    if (closeBtn) {
      var d = closeBtn.closest('[data-mobile-menu]') || document.getElementById(closeBtn.dataset.backdropFor);
      if (d) {
        d.dataset.open = 'false';
        d.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        var bd2 = backdropFor(d.id);
        if (bd2) bd2.dataset.open = 'false';
      }
      return;
    }
  });

  // desktop mega-menu: open on hover/focus, close on mouseleave of the whole nav row
  document.querySelectorAll('[data-mega-nav]').forEach(function (nav) {
    var items = nav.querySelectorAll('[data-nav-item]');
    function closeAll() { items.forEach(function (it) { it.dataset.megaOpen = 'false'; var t = it.querySelector('[data-mega-trigger]'); if (t) t.setAttribute('aria-expanded', 'false'); } ); }
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      if (!trigger) return;
      item.addEventListener('mouseenter', function () { closeAll(); item.dataset.megaOpen = 'true'; trigger.setAttribute('aria-expanded', 'true'); });
      trigger.addEventListener('focus', function () { closeAll(); item.dataset.megaOpen = 'true'; trigger.setAttribute('aria-expanded', 'true'); });
    });
    nav.addEventListener('mouseleave', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  });

  // hero photo rotation (creative hero, ported from shop-screens.jsx Hero "creative" variant)
  document.querySelectorAll('[data-hero-rotator]').forEach(function (rotator) {
    var imgs = rotator.querySelectorAll('.rw-hero-media__img');
    if (imgs.length < 2) return;
    // only sync the teaser card swap when every rotating photo has its own linked product —
    // otherwise leave whichever teaser is already showing (usually the first) alone
    var teasers = rotator.parentElement.querySelectorAll('[data-hero-teaser]');
    var syncTeasers = teasers.length === imgs.length;
    var i = 0;
    setInterval(function () {
      imgs[i].style.opacity = '0';
      if (syncTeasers) { teasers[i].style.opacity = '0'; teasers[i].style.pointerEvents = 'none'; }
      i = (i + 1) % imgs.length;
      imgs[i].style.opacity = '1';
      if (syncTeasers) { teasers[i].style.opacity = '1'; teasers[i].style.pointerEvents = 'auto'; }
    }, 5000);
  });

  // collection filters: auto-submit the facets form on change (no separate "Anwenden" button)
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-facet-input]');
    if (input) input.closest('form[data-facets-form]').submit();
  });

  // collection "Mehr laden": fetch the next page and append its product grid instead of a full reload
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    var gridSelector = btn.dataset.gridSelector;
    var url = btn.href;
    btn.textContent = '…';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(gridSelector);
        var newBtn = doc.querySelector('[data-load-more]');
        var currentGrid = document.querySelector(gridSelector);
        if (newGrid && currentGrid) {
          // newGrid.children is a live collection - appendChild() moves each node out of it
          // as we go, shifting every later index down by one, so a plain forEach over it skips
          // roughly every other item. Snapshot it into a plain array first so the iteration
          // isn't affected by the very moves it's making.
          Array.prototype.slice.call(newGrid.children).forEach(function (child) { currentGrid.appendChild(child); });
        }
        if (newBtn) { btn.href = newBtn.href; btn.textContent = newBtn.textContent; }
        else { btn.remove(); }
        if (window.RWWishlist) document.dispatchEvent(new Event('DOMContentLoaded'));
      });
  });

  // customer address book: toggle edit panel, confirm before delete
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-address-edit-toggle]');
    if (toggle) {
      var panel = document.querySelector('[data-address-edit-panel="' + toggle.dataset.addressEditToggle + '"]');
      if (panel) panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
      return;
    }
    var del = e.target.closest('[data-confirm-delete]');
    if (del && !window.confirm('Diese Adresse wirklich löschen?')) {
      e.preventDefault();
    }
  });

  // customer login: toggle between the login and "forgot password" panel. No separate
  // /account/recover page exists (linking there directly 404s — that path is only the
  // recover_customer_password form's POST target), so both panels live in login.liquid and
  // are shown/hidden here instead.
  var loginPanel = document.querySelector('[data-login-panel]');
  var recoverPanel = document.querySelector('[data-recover-panel]');
  if (loginPanel && recoverPanel) {
    var showRecover = function () { loginPanel.hidden = true; recoverPanel.hidden = false; };
    var showLogin = function () { recoverPanel.hidden = true; loginPanel.hidden = false; };
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-recover-toggle]')) return;
      e.preventDefault();
      recoverPanel.hidden ? showRecover() : showLogin();
    });
    // Reopen the recover panel after Shopify redirects back here post-submit (error or success) —
    // the URL hash isn't sent to the server, so this can't be decided in Liquid.
    if (window.location.hash === '#recover' || recoverPanel.querySelector('.rw-notification')) {
      showRecover();
    }
  }

  // cookie consent banner
  var banner = document.getElementById('rw-cookie-banner');
  if (banner) {
    if (localStorage.getItem('rw_cookie_consent')) {
      banner.remove();
    } else {
      banner.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cookie-choice]');
        if (!btn) return;
        localStorage.setItem('rw_cookie_consent', btn.dataset.cookieChoice);
        banner.remove();
      });
    }
  }
})();
